/**
 * CheckoutCompletePage Component
 */

import './styles.scss';

import { RouteMatch } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityTransitionGroup } from 'velocity-react';

import Page from '../../../containers/Page';
import LinkButton from '../../atoms/buttons/LinkButton';
import { IconWarningLarge } from '../../atoms/images/Icon';
import { IconAudioHuge, IconInvoiceHuge, IconLicenseHuge } from '../../atoms/images/Icon/huge-icons';
import Heading from '../../atoms/text/Heading';
import { OrderPagePath } from '../account/Orders';

// Page Path
export const CheckoutCompletePagePath = '/my/checkout/complete';

// Page Props
type CheckoutCompletePageProps = RouteMatch;

interface IOwnState {
  orderId: string | null;
}

const classes = new BEM('checkout-complete');

class CheckoutCompletePage extends React.Component<CheckoutCompletePageProps, IOwnState> {
  constructor(props: CheckoutCompletePageProps) {
    super(props);

    this.state = {
      orderId: props.location.query.order || null,
    };
  }

  render() {
    return (
      <VelocityTransitionGroup
        component={Page}
        id="checkout-complete"
        enter={{ animation: 'transition.expandIn', duration: 1000, delay: 750 }}
        leave={{ animation: 'transition.shrinkOut', duration: 750 }}
        runOnMount
      >{this.state.orderId ? (
        <div key="license-files" { ...classes('content') }>
          <Heading is="h3" { ...classes('title') }>Here are your files:</Heading>
          <ul { ...classes('license-files-list') }>
            <li { ...classes('license-files-list__item') }>
              <div { ...classes('license-files-list__item__background') } />
              <IconInvoiceHuge { ...classes('license-files-list__item__icon') } />
              <Heading is="h6" { ...classes('license-files-list__item__title') }>Invoice</Heading>
              <div { ...classes('license-files-list__item__actions') }>
                <LinkButton
                  to={{
                    pathname: OrderPagePath(this.state.orderId),
                    query: {
                      view: 'invoice',
                    },
                  }}
                  label="View"
                  colorScheme="accent"
                  variant="pill"
                  size="small"
                />
              </div>
            </li>
            <li { ...classes('license-files-list__item') }>
              <div { ...classes('license-files-list__item__background') } />
              <IconLicenseHuge { ...classes('license-files-list__item__icon') } />
              <Heading is="h6" { ...classes('license-files-list__item__title') }>License</Heading>
              <div { ...classes('license-files-list__item__actions') }>
                <LinkButton
                  to={{
                    pathname: OrderPagePath(this.state.orderId),
                    search: '?view=license',
                  }}
                  label="View"
                  colorScheme="accent"
                  variant="pill"
                  size="small"
                />
              </div>
            </li>
            <li { ...classes('license-files-list__item') }>
              <div { ...classes('license-files-list__item__background') } />
              <IconAudioHuge { ...classes('license-files-list__item__icon') } />
              <Heading is="h6" { ...classes('license-files-list__item__title') }>Audio files</Heading>
              <div { ...classes('license-files-list__item__actions') }>
                <LinkButton
                  to={{
                    pathname: OrderPagePath(this.state.orderId),
                    query: {
                      view: 'music',
                    },
                  }}
                  label="View"
                  colorScheme="accent"
                  variant="pill"
                  size="small"
                />
              </div>
            </li>
          </ul>
        </div>
      ) : (
        <div key="error" { ...classes('content', 'error') }>
          <IconWarningLarge />
          <Heading is="h2">Something went wrong.</Heading>
          <Heading is="h4">
            Provided order ID is invalid.
            If this is unintended, please contact us at&nbsp;+1&nbsp;888-423-6665&nbsp;(NA)
            or +33&nbsp;1&nbsp;70&nbsp;38&nbsp;73&nbsp;50&nbsp;(EU).
          </Heading>
        </div>
      )}
      </VelocityTransitionGroup>
    );
  }
}

export default CheckoutCompletePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/CheckoutComplete/index.tsx